<template>
  <div style="padding: 0 10px 30px" ref="principalOverviewWorkRef">
    <a-row class="child-full-width overview-bgColor">
      <a-col :span="24" class="title-1" style="margin: 15px 0">校园情绪概览</a-col>
      <a-col :span="24" style="padding: 20px; background-color: #fff; border-radius: 10px">
        <a-row :gutter="[15, 15]" class="row-box" style="padding-top: 10px">
          <a-col :lg="7" :md="9" :sm="24" :xl="4">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择年级"
              v-model="queryParam.gradeId"
              dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
              :isShowEmpty="false"
              @select="
                (record) => {
                  $set(queryParam, 'classId', undefined)
                  $set(selectLevelObj, 'grade', record)
                }
              "
              @clear="$set(queryParam, 'classId', undefined)"
            />
          </a-col>
          <a-col :lg="7" :md="9" :sm="24" :xl="4">
            <j-dict-select-tag
              style="width: 100%"
              placeholder="请选择班级"
              v-model="queryParam.classId"
              :dictCode="
                'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
              "
              :disabled="!queryParam.gradeId"
              :isShowEmpty="false"
              @select="
                (record) => {
                  $set(selectLevelObj, 'class', record)
                }
              "
            />
          </a-col>
          <a-col :lg="6" :md="9" :sm="24" :xl="4">
            <a-range-picker
              :value="rangeDate"
              :getCalendarContainer="(node) => node.parentNode"
              style="width: 100%"
              @change="onRangeChange"
            />
          </a-col>

          <a-col v-for="(item, index) in searchItem" :key="index" :span="2" class="tag-col">
            <div :style="{ borderLeft: `4px solid ${searchItemColor[index]}` }" class="tag-item">
              <span class="tag-name">{{ item }}</span>
              <a-icon class="delete-icon" type="close-circle" @click="deleteBtn(item, index)" />
            </div>
          </a-col>

          <a-col v-if="contrastInputStatus" :span="4" class="select-box">
            <a-select
              :not-found-content="null"
              show-search
              @search="handleSearch"
              @inputKeydown.enter="
                () => {
                  contrastInputStatus = false
                }
              "
            >
              <div slot="dropdownRender">
                <recycle-scroller
                  :buffer="1000"
                  :item-size="40"
                  :items="keyword"
                  :prerender="200"
                  class="virtual-list"
                  key-field="period_id"
                  style="max-height: 200px"
                >
                  <template v-slot="{ item, index }">
                    <div :key="index" class="list-item" @click="handleSelect(item.period_id, item)">
                      {{ item.name }}
                    </div>
                  </template>
                </recycle-scroller>
              </div>
            </a-select>
            <a-icon
              class="select-del-icon"
              type="close-circle"
              @click="
                () => {
                  contrastInputStatus = false
                }
              "
            />
          </a-col>
          <a-col :span="3">
            <div style="display: flex">
              <a-button style="margin-right: 10px" @click="addContrast">+ 添加对比</a-button>
              <a-button icon="search" type="primary" @click="chaDate(true)">查询</a-button>
            </div>
          </a-col>
        </a-row>
        <a-col :span="16" style="padding-right: 8px">
          <a-card :bordered="false" :loading="loading" class="left-card-box">
            <LineChart
              ref="schoolMoodRef"
              :dataSource="schoolMood"
              :fields="moodField"
              :title="`${lineMoodTitle}情绪变化趋势`"
              height="280px"
              showAvgBtn
            >
              <template slot="titleExtra">
                <a-button class="add-btn" type="primary" @click="addEventClick">添加事件</a-button>
              </template>
            </LineChart>
          </a-card>
        </a-col>
        <a-col :span="8" style="padding-left: 8px">
          <a-tabs @change="changeTab" class="emotional-trend-card">
            <a-tab-pane v-for="item in emotionalTrendTabs" :key="item.key" :tab="item.tab">
              <a-card :bordered="false" :loading="loading">
                <TableList
                  :columns="emotionalTrend.columns"
                  :scroll="{ y: 220 }"
                  bordered
                  :tableData="emotionalTrend.tableData"
                  style="height: 294px"
                  @addContrast="(record) => addContrastCell(record)"
                >
                  <div slot="total" slot-scope="{ record }" style="text-align: left">
                    <div style="font-size: 16px; font-weight: bold">
                      {{ record.total }}
                    </div>
                    <div>
                      <img
                        v-if="record.total != record.school"
                        :src="
                          require(`@assets/imgs/school/${
                            record.total > record.school ? 'rise' : 'descend'
                          }.png`)
                        "
                        style="width: 10px; margin-right: 5px"
                        alt=""
                      />
                      <span style="font-size: 13px">全校平均值{{ record.school }}</span>
                    </div>
                  </div>
                </TableList>
              </a-card>
            </a-tab-pane>
          </a-tabs>
        </a-col>
        <!--情绪变化描述-->
        <a-col :span="24">
          <MoodChangeDesc ref="moodChangeDescRef" :dataRange="rangeDate" style="width: 100%" />
        </a-col>
      </a-col>
    </a-row>
    <!--设备采集情况-->
    <div class="title-1" style="margin: 20px 0 10px">设备采集情况</div>
    <div class="equipment-list flex-between">
      <div class="equipment-item" style="display: flex; justify-content: space-between">
        <div>
          <div style="font-size: 16px">学生总数</div>
          <div class="font-text">
            <CountAnimation :end-val="collectedInfo.studentCount" />
          </div>
        </div>
        <div>
          <div style="font-size: 16px">人脸采集数</div>
          <div class="font-text">
            <CountAnimation :end-val="collectedInfo.studentFaceCount" />
          </div>
        </div>
        <div class="icon-area flex-center" style="background: #eef4ff">
          <img
            :src="require(`@/assets/imgs/school/guardStuTotal.png`)"
            style="width: 24px; height: 24px"
            alt=""
          />
        </div>
      </div>
      <div class="equipment-other-item">
        <div class="flex-align-center">
          <!--时间标签-->
          <div class="flex-align-center tag-list">
            <div
              v-for="(item, index) in timeTagList"
              :key="index"
              :class="{ 'list-tag-item': true, 'active-tag': equipmentTagIndex == index }"
              @click="equipmentTagIndex = index"
            >
              {{ item }}
            </div>
          </div>
          <a-range-picker
            v-model="equipmentDateRange"
            :allow-clear="false"
            :getCalendarContainer="(node) => node.parentNode"
            style="width: 220px; margin: 0 15px"
          />
          <a-button icon="search" type="primary" @click="equipmentQuery(true)">查询</a-button>
        </div>
        <div class="flex-align-center" style="margin-top: 5px; padding-left: 10px">
          <div style="flex: 1">
            <div style="font-size: 16px">未采集人数</div>
            <div :style="{ marginTop: '3px', fontSize: '28px', fontWeight: 600, color: '#FA3A25' }">
              <CountAnimation :end-val="baseMapInfo.haveBaseMapCount" />
            </div>
            <div class="flex-align-center">
              <div style="margin-right: 10px">
                无底图
                <span class="num">{{ baseMapInfo.noBaseMapCount }}</span>
                人
              </div>
              <div>
                人脸录入未采集
                <span class="num">{{ baseMapInfo.haveBaseMapCount }}</span>
                人
              </div>
              <a-button type="primary" ghost style="margin-left: 20px" @click="goNotCollectDetail">
                查看详情
              </a-button>
            </div>
          </div>
          <div style="flex: 1; padding-left: 10px">
            <div style="font-size: 16px">抓拍覆盖率</div>
            <div :style="{ marginTop: '3px', fontSize: '28px', fontWeight: 600 }">
              <CountAnimation :end-val="collectedInfo.coverageRate" :attr="{ decimals: 2 }" />
              %
            </div>
            <div class="flex-align-center">
              <div>
                已抓拍学生总数
                <span class="num">{{ collectedInfo.cameraStudentFaceCount || 0 }}</span>
              </div>
              <div style="margin: 0 5px">/</div>
              <div>
                人脸录入数
                <span class="num">{{ collectedInfo.studentFaceCount || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--班主任工作管理-->
    <div class="child-full-width teacher-manage-bgColor" style="margin-top: 20px">
      <div class="title-1" style="padding: 15px 0 5px 0">{{ remindStu.title }}</div>
      <div class="row-box-card flex-align-center">
        <!--提醒学生概况-->
        <div class="pie-item-card">
          <div class="flex-align-center">
            <!--时间标签-->
            <div class="flex-align-center tag-list">
              <div
                v-for="(item, index) in timeTagList3"
                :key="index"
                :class="{ 'list-tag-item': true, 'active-tag': remindStuTagIndex == index }"
                @click="remindStuTagIndex = index"
              >
                {{ item }}
              </div>
            </div>
            <a-range-picker
              v-model="remindStuDateRange"
              :getCalendarContainer="(node) => node.parentNode"
              style="width: 220px; margin: 0 15px"
            />
            <a-button icon="search" type="primary" @click="remindStuQuery(true)">查询</a-button>
          </div>
          <div class="title-2" style="margin: 15px 0 10px 0">
            班主任提醒名单关爱率
            <span class="title-num">{{ teacherHandInfo.processRate }}%</span>
            ，未关爱率
            <span class="title-num" style="color: #e16156">
              {{ teacherHandInfo.untreatedRate }}%
            </span>
          </div>
          <div>
            已处理提醒人次
            <span class="sub-text">{{ teacherHandInfo.doneNum }}</span>
            / 总提醒人次
            <span class="sub-text">{{ teacherHandInfo.totalNum }}</span>
            ， 未处理提醒人次
            <span class="sub-text">{{ teacherHandInfo.pendingNum }}</span>
            / 总提醒人次
            <span class="sub-text">{{ teacherHandInfo.totalNum }}</span>
          </div>
          <PieChartCard
            :item="remindStu.list[0]"
            :legendStyle="{ transform: 'translateY(-20px)' }"
            style="height: 240px; border: none; padding: 0; margin-top: 20px"
          />
        </div>
        <div class="pie-item-card">
          <div class="title-2 flex-align-center" style="margin: 2px 0 10px 0">
            <span class="title-block"></span>
            学生提醒
          </div>
          <ClassTeaHandSituat ref="classTeaHandSituatRef" style="padding: 0" />
        </div>
      </div>
      <!--提醒人次-->
      <ReminderNumCard style="height: 340px; margin: 15px 0 20px 0" />
    </div>
    <!--班主任使用概览-->
    <a-row>
      <a-col :span="24" class="title-1" style="margin-bottom: 10px">班主任使用概览</a-col>
      <a-col :span="24" style="overflow: hidden; background-color: #fff; border-radius: 10px">
        <a-col :span="12" style="padding-right: 8px">
          <a-card :bordered="false" :loading="loading" class="left-card-box" style="border: none">
            <LineChart
              ref="teacherVisitChartRef"
              :dataSource="teacherVisitChart.dataSource"
              :fields="teacherVisitChart.fields"
              height="260px"
              :grid="grid"
              style="margin-bottom: 20px"
              title="教师访问量趋势"
            >
              <div slot="titleExtra" class="flex-align-center">
                <!--时间标签-->
                <div class="flex-align-center tag-list">
                  <div
                    v-for="(item, index) in timeTagList2"
                    :key="index"
                    :class="{ 'list-tag-item': true, 'active-tag': teaVisitTagIndex == index }"
                    @click="teaVisitTagIndex = index"
                  >
                    {{ item }}
                  </div>
                </div>
                <div>
                  <a-range-picker
                    v-model="teaVisitDateRange"
                    :allow-clear="false"
                    style="width: 220px; margin: 0 15px"
                  />
                </div>
                <a-button icon="search" type="primary" @click="teaVisitQuery(true)">查询</a-button>
              </div>
            </LineChart>
          </a-card>
        </a-col>
        <a-col :span="12" style="padding-left: 8px">
          <a-card
            :bordered="false"
            :loading="loading"
            class="right-card-box"
            style="padding: 0; border: none"
          >
            <div class="title-right-extra flex-between">
              <div>
                {{ teacherUseList.title }}
              </div>
              <div class="flex-align-center">
                <a-button
                  type="primary"
                  style="margin: 0 15px; border-color: #13b999; background-color: #13b999"
                  :loading="exportXlsLoading"
                  @click="
                    handleExportXls('教师使用情况', {
                      beginDate: teaVisitDateRange[0],
                      endDate: teaVisitDateRange[1],
                    })
                  "
                >
                  导出
                </a-button>
                <!--<a-popconfirm-->
                <!--  title="确定要一键提醒吗？"-->
                <!--  ok-text="确认"-->
                <!--  cancel-text="取消"-->
                <!--  @confirm="teacherUseOneRemind()"-->
                <!--&gt;-->
                <!--  <a-button type="primary" :loading="remindLoading">一键提醒</a-button>-->
                <!--</a-popconfirm>-->

                <a-button type="primary" @click="viewTeaUsageModal">一键提醒</a-button>
              </div>
            </div>
            <a-table
              :dataSource="teacherUseList.tableData"
              :columns="teacherUseList.columns"
              :loading="teaLoading"
              :scroll="{ y: 210 }"
              bordered
              size="small"
              :pagination="false"
              @change="handleTableChange"
            />
          </a-card>
        </a-col>
      </a-col>
    </a-row>
    <div class="child-full-width psy-teacher-manage-bgColor" style="margin-top: 20px">
      <!--心理老师工作管理-->
      <div class="title-1" style="padding: 15px 0 5px 0">{{ mentalHealthObj.title }}</div>
      <div class="row-box flex-align-center" style="flex-wrap: wrap; padding: 0">
        <div v-for="(item, index) in mentalHealthObj.list" :key="index" class="pie-item">
          <PieChartCard v-if="index == 0" :item="item">
            <div class="flex-align-center">
              <!--时间标签-->
              <div class="flex-align-center tag-list">
                <div
                  v-for="(item, index) in timeTagList3"
                  :key="index"
                  :class="{ 'list-tag-item': true, 'active-tag': mentalTagIndex == index }"
                  @click="mentalTagIndex = index"
                >
                  {{ item }}
                </div>
              </div>
              <a-range-picker
                v-model="mentalDateRange"
                :getCalendarContainer="(node) => node.parentNode"
                style="width: 220px; margin: 0 15px"
              />
              <a-button icon="search" type="primary" @click="mentalQuery(true)">查询</a-button>
            </div>
          </PieChartCard>
          <MyPlan v-else :planData="item" />
        </div>
      </div>
      <!--重点关爱学生管理-->
      <div class="title-1" style="margin-top: 10px">{{ mainCareStu.title }}</div>
      <div class="row-box flex-align-center" style="flex-wrap: wrap; padding: 0">
        <div v-for="(item, index) in mainCareStu.list" :key="index" class="pie-item">
          <PieChartCard :item="item" style="height: 340px" />
        </div>
      </div>
    </div>
    <!--学生/家长活跃情况-->
    <a-row v-if="isShowActivity">
      <a-col :span="24" class="title-1" style="margin: 0 0 10px">学生/家长活跃情况</a-col>
      <a-col :span="24">
        <a-card :bordered="false" :loading="loading" class="left-card-box">
          <div class="flex-between">
            <div style="margin-bottom: 10px; font-size: 16px; font-weight: bold; color: #1e1e1e">
              学生/家长活跃度对比
            </div>
            <div class="flex-align-center">
              <div class="flex-align-center tag-list">
                <div
                  v-for="(item, index) in timeTagList2"
                  :key="index"
                  :class="{ 'list-tag-item': true, 'active-tag': activityTagIndex == index }"
                  @click="activityTagIndex = index"
                >
                  {{ item }}
                </div>
              </div>
              <a-range-picker
                v-model="vitalityDateRange"
                :allow-clear="false"
                style="width: 220px; margin: 0 15px"
              />
              <a-button icon="search" type="primary" @click="vitalityQuery(true)">查询</a-button>
            </div>
          </div>
          <a-row :gutter="[30, 0]">
            <a-col :span="12">
              <LineChart
                ref="studentActivityRef"
                :dataSource="studentActivity"
                :fields="['学生活跃度']"
                :grid="grid"
                height="250px"
                style="margin-bottom: 10px"
              />
            </a-col>
            <a-col :span="12">
              <LineChart
                ref="parentVisitRef"
                :dataSource="parentVisit"
                :fields="['家长活跃度']"
                :grid="grid"
                height="250px"
                style="margin-bottom: 10px"
              />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <!--情绪记录-->
    <!--<MoodRecordCom />-->
    <!--添加事件模态框-->
    <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
    <!--教师关怀模态框-->
    <TeacherCareModal ref="teacherCareModal" />
    <!--教师使用情况详情-->
    <TeacherUsageModal ref="teacherUsageModalRef" :tableData="teacherUseList.tableData" />
    <!--回到顶部-->
    <a-back-top :target="targetFn" :visibilityHeight="400" />
  </div>
</template>

<script>
import CountAnimation from '@/components/CountAnimation'
import { getAction } from '@api/manage'
import PieChartCard from '@/comUi/PieChartCard'
import MyPlan from './components/MyPlan.vue'
import ReminderNumCard from '@/comUi/ReminderNumCard'
import ClassTeaHandSituat from '@/comUi/ClassTeaHandSituat'
import LineChart from '@/components/echartZyz/components/LineChart'
import TableList from '@/components/chart/TableList'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css' // 引入它的 css
import moment from 'moment'
import AddEventModal from '@/comUi/AddEventModal'
import MoodRecordCom from '@/comUi/MoodRecordCom'
import TeacherCareModal from '@/comUi/TeacherCareModal'
import TeacherUsageModal from './components/TeacherUsageModal'
import MoodChangeDesc from './components/MoodChangeDesc'

import {
  addLineCompare,
  deleteLineCompare,
  handleLineChartData,
  randomColor,
  saveFieldsArrKey,
  simpleDebounce,
} from '@/utils/util'
import { getWeekDateRange, getMonthDateRange, formatYearMonthDate } from '@/utils/date'
import { getSchoolTerm } from '@/utils/termDate'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { mapGetters } from 'vuex'
const { startDate, endDate } = getSchoolTerm()
const dateRangMapObj = {
  0: getWeekDateRange(), // 本周日期范围
  1: getMonthDateRange(), // 本月日期范围
  2: [startDate, endDate], // 本学期日期范围
}

export default {
  name: 'school-PrincipalOverviewWork',
  mixins: [JeecgListMixin],
  components: {
    CountAnimation,
    // CreatePlan,
    PieChartCard,
    MyPlan,
    ReminderNumCard,
    RecycleScroller,
    LineChart,
    TableList,
    AddEventModal,
    MoodRecordCom,
    TeacherCareModal,
    ClassTeaHandSituat,
    TeacherUsageModal,
    MoodChangeDesc,
  },
  computed: {
    ...mapGetters(['identityId']),
  },
  props: {
    modeType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      disableMixinCreated: false,
      queryParam: {},
      selectLevelObj: {
        grade: {},
        class: {},
      },
      rangeDate: [],
      searchItem: [],
      searchItemColor: [],
      schoolMood: [],
      moodField: ['愉悦指数', '关爱名单愉悦指数'],
      contrastInputStatus: false,
      keyword: [],
      searchContextList: [],
      lineMoodTitle: '',
      emotionalTrendTabs: [
        {
          tab: '年级情绪指数',
          key: '0',
        },
        {
          tab: '班级情绪指数',
          key: '1',
        },
      ],
      emotionalTrend: {
        url: '/statistic/gradeTrendsRanking',
        columns: [
          {
            title: '序号',
            dataIndex: 'ranking',
            align: 'center',
            width: 60,
            customRender: (_, record, index) => index + 1,
          },
          {
            title: '年级',
            dataIndex: 'name',
            align: 'center',
          },
          {
            title: '情绪指数',
            dataIndex: 'total',
            align: 'center',
            sorter: (a, b) => {
              return a.total - b.total
            },
            scopedSlots: { customRender: 'total' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            width: 100,
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
      },
      grid: { top: '10%', bottom: '25%', left: '8%', right: '4%' },
      teacherVisitChart: {
        fields: ['教师访问次数'],
        dataSource: [],
      },
      url: {
        // 教师使用情况导出
        exportXlsUrl: '/statistic/teacherSituationExport',
      },
      remindLoading: false,
      teacherUseList: {
        title: '教师使用情况',
        columns: [
          {
            title: '排名',
            dataIndex: 'index',
            align: 'center',
            width: 60,
            customRender: (_, record, index) => index + 1,
          },
          {
            title: '班级',
            dataIndex: 'className',
            align: 'center',
          },
          {
            title: '教师姓名',
            dataIndex: 'teacherName',
            align: 'center',
            customRender: (_, record) => {
              return (
                <div
                  style="color: #189EFF;cursor: pointer;"
                  onClick={() => this.viewTeacherCare(record)}
                >
                  {record.teacherName}
                </div>
              )
            },
          },
          {
            title: '未处理提醒',
            dataIndex: 'unDealWarnCnt',
            align: 'center',
            sorter: (a, b) => a.unDealWarnCnt - b.unDealWarnCnt,
            customRender: (_, record) => {
              return (
                <div style={{ color: record.unDealWarnCnt > 0 ? '#FF4D4F' : '' }}>
                  {record.unDealWarnCnt}
                </div>
              )
            },
          },
          {
            title: '访问次数',
            dataIndex: 'visitCnt',
            align: 'center',
            sorter: (a, b) => a.visitCnt - b.visitCnt,
          },
          {
            title: '操作',
            dataIndex: 'teacherlRemind',
            align: 'center',
            // scopedSlots: { customRender: 'teacherlRemind' },
            customRender: (_, record) => {
              return (
                <a-popconfirm
                  title="确定要提醒吗？"
                  ok-text="确认"
                  cancel-text="取消"
                  onConfirm={() => this.teacherRemindList(record)}
                >
                  <span style={{ color: '#1890ff', cursor: 'pointer' }}>提醒</span>
                </a-popconfirm>
              )
            },
          },
        ],
        tableData: [],
      },
      studentActivity: [],
      parentVisit: [],
      pagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '50', '100'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showSizeChanger: true,
        total: 0,
      },
      teaLoading: false,
      compareData: [],
      loading: false,
      stuCardList: [
        {
          title: '重点关爱学生',
          list: [
            {
              value: 0,
              key: 'zgaCnt',
              label: '重点关爱学生数',
              backgroundColor: '#F66860',
              value2: 0,
              key2: 'zgaCnt2',
              label2: '已关爱学生次数',
            },
            {
              value: 0,
              key: 'pgCnt',
              label: '待评估学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
            {
              value: 0,
              key: 'txCnt',
              label: '待危机干预学生数',
            },
            {
              value: 0,
              key: 'txFdyyCnt',
              label: '心理辅导预约',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              key: 'fdtzCnt ',
              label: '已辅导学生数',
            },
          ],
        },
        {
          title: '小叮当提醒学生',
          list: [
            {
              value: 100,
              label: '提醒学生',
              backgroundColor: '#1783E8',
            },
            {
              value: 0,
              label: '已查看学生数',
            },
            {
              value: 0,
              label: '已归档学生数',
            },
          ],
        },
      ],
      stuInfoCollectObj: {},
      mentalHealthObj: {
        title: '心理老师工作管理',
        list: [
          {
            title: '心理辅导',
            showTagList: true,
            path: '/CommonPage/PsyCounselAppointment',
            rate: 0,
            query: {},
            chartData: [
              { value: 0, name: '预约未确认' },
              { value: 0, name: '未辅导' },
              { value: 0, name: '已辅导' },
            ],
            pieText: [0, '总辅导次数'],
            legendArr: [
              { value: 0, name: '辅导记录', loading: true },
              { value: 0, name: '班主任预约', loading: true },
              { value: 0, name: '家长预约', loading: true },
              { value: 0, name: '危机上报', loading: true },
              // { value: 0, name: '危机上报', icon: 'imgs/commonPage/remind' },
            ],
            subTitle: '心理辅导预约处理率',
          },
          {
            title: '心理健康工作统计概况',
            chartData: [
              { value: 0, name: '心理测评次数', path: '/CommonPage/MyWordPlan' },
              { value: 0, name: '心理辅导次数', path: '/CommonPage/PsyCounselNum' },
              { value: 0, name: '家访次数', path: '' },
              { value: 0, name: '班主任沟通次数', path: '' },
            ],
          },
        ],
      },
      mainCareStu: {
        title: '重点关爱学生管理',
        list: [
          {
            title: '危机学生',
            chartData: [
              { value: 0, name: '一级学生人数' },
              { value: 0, name: '二级学生人数' },
              { value: 0, name: '三级学生人数' },
            ],
            pieText: [0, '总人数'],
          },
          {
            title: '重点学生关爱情况',
            path: '/CommonPage/MainStuCareSituation',
            chartData: [
              { value: 0, name: '待关爱学生数' },
              { value: 0, name: '已关爱学生数' },
            ],
            pieText: [0, '总人数'],
            legendArr: [
              { value: 0, name: '累计关爱次数', isNotHasDetail: true },
              { value: 0, name: '已关爱学生数' },
              { value: 0, name: '待关爱学生数' },
            ],
          },
        ],
      },
      remindStu: {
        title: '班主任工作管理',
        list: [
          {
            // title: '班主任提醒处理情况',
            // subTitle: '教师提醒名单关爱率',
            showTagList: false,
            rate: 0,
            hideLegend: true,
            path: '/CommonPage/XddRemindStudent',
            chartData: [
              { value: 0, name: '已处理提醒数' },
              { value: 0, name: '未处理提醒数' },
            ],
            pieText: [0, '总提醒数'],
          },
        ],
      },
      teacherHandInfo: {},
      remindStuTagIndex: 0,
      remindStuDateRange: [],
      mentalTagIndex: 0,
      mentalDateRange: [],
      timeTagList: ['上周', '本月', '本学期'],
      timeTagList2: ['本周', '本月', '本学期'],
      timeTagList3: ['本周', '本月', '本学期', '全部'],
      equipmentTagIndex: 0,
      teaVisitTagIndex: 1,
      equipmentDateRange: [],
      teaVisitDateRange: [],
      vitalityDateRange: [],
      isShowActivity: false, // 是否显示活跃情况区域
      activityTagIndex: 0,
      baseMapInfo: {
        haveBaseMapCount: 0,
        noBaseMapCount: 0,
      },
      collectedInfo: {},
      savedScrollPosition: 0,
      isDeactivated: false, // 页面是否被销毁过，不包括第一次进入
    }
  },
  created() {
    this.isDeactivated = false
    console.log('触发created')
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.checkCOpenStatus()
    this.chaDate()
    this.getKeyCareStudents()
    this.getRectorWorkbench()
  },
  mounted() {
    this.$refs.moodChangeDescRef.addItem({
      name: '全校',
      type: 1,
    })
    // 监听window滚动
    window.addEventListener('scroll', () => {
      console.log('window滚动', window.scrollY)
      this.savedScrollPosition = window.scrollY
    })
  },
  activated() {
    if (!this.isDeactivated) return
    const dateRangeObj = {
      beginDate: formatYearMonthDate(this.teaVisitDateRange[0]),
      endDate: formatYearMonthDate(this.teaVisitDateRange[1]),
    }
    // 该表的设备ID会变化，所以只要进入该页面都要请求一次(不包含第一次)
    this.getTeacherSituation(dateRangeObj)
  },
  deactivated() {
    this.isDeactivated = true
  },
  watch: {
    equipmentTagIndex: {
      handler(val) {
        if (val == -1) return
        const { startDate, endDate } = getSchoolTerm()
        const dateRangObj = {
          0: getWeekDateRange(-1), // 上周日期范围
          1: getMonthDateRange(), // 本月日期范围
          2: [startDate, endDate], // 本学期日期范围
        }
        this.equipmentDateRange = dateRangObj[val]
        this.equipmentQuery()
      },
      immediate: true,
    },
    remindStuTagIndex: {
      handler(val) {
        if (val == -1) return
        this.remindStuDateRange = dateRangMapObj[val]
        this.remindStuQuery()
      },
      immediate: true,
    },
    teaVisitTagIndex: {
      handler(val) {
        if (val == -1) return
        this.teaVisitDateRange = dateRangMapObj[val]
        this.teaVisitQuery()
      },
      immediate: true,
    },
    mentalTagIndex: {
      handler(val) {
        if (val == -1) return
        this.mentalDateRange = dateRangMapObj[val]
        this.mentalQuery()
      },
      immediate: true,
    },
    activityTagIndex: {
      async handler(val) {
        if (val == -1) return
        this.vitalityDateRange = dateRangMapObj[val]
        this.vitalityQuery()
      },
      immediate: true,
    },
  },
  methods: {
    // 查询事件  是否点击按钮操作：isBtnAction
    async chaDate(isBtnAction = false) {
      this.contrastInputStatus = false
      this.searchItem = []
      this.context2 = ''
      await this.loadData()
      this.setLineMoodTitle()
      this.getSearchKeyword()
      if (isBtnAction) {
        this.$refs.moodChangeDescRef.addItem(
          {
            id: this.queryParam.classId || this.queryParam.gradeId,
            type: this.queryParam.classId ? 3 : this.queryParam.gradeId ? 2 : 1,
            name: this.selectLevelObj.class.text || this.selectLevelObj.grade.text,
          },
          true
        )
      }
    },
    loadData() {
      this.getSchoolChangeTrend()
      // this.getStuPraCompare()
      this.getTrendsRanking()
    },
    // 获取校园变化趋势折线图数据
    getSchoolChangeTrend() {
      // this.$refs.schoolMoodRef.showLoading()
      getAction('/statistic/schoolMoodTrend', this.queryParam)
        .then((res) => {
          if (res.success) {
            const { filedList, lineData } = handleLineChartData(res.result)
            this.schoolMood = lineData
            this.moodField = filedList
          }
        })
        .finally(() => {
          // this.$refs.schoolMoodRef.hideLoading()
        })
    },
    // 设置心情变化趋势标题
    setLineMoodTitle() {
      this.lineMoodTitle = this.queryParam.classId
        ? this.selectLevelObj.class.text
        : this.queryParam.gradeId
        ? this.selectLevelObj.grade.text
        : '校园'
    },
    // 添加对比
    addCompareData(params) {
      // console.log('添加对比参数', {...this.queryParam, ...params});
      getAction('/statistic/compareData', { ...this.queryParam, ...params })
        .then((res) => {
          if (res.success) {
            this.compareData = res.result
            // this.schoolMood.push(this.compareData)
            const { lineData, filedList } = addLineCompare(
              this.schoolMood,
              this.moodField,
              this.compareData
            )
            this.schoolMood = lineData
            this.moodField = filedList
          }
        })
        .finally(() => {})
    },
    changeTab(key) {
      const keyObj = {
        0: {
          title: '年级',
          url: '/statistic/gradeTrendsRanking',
        },
        1: {
          title: '班级',
          url: '/statistic/classTrendsRanking',
        },
      }
      this.emotionalTrend.url = keyObj[key].url
      this.$set(this.emotionalTrend.columns[1], 'title', keyObj[key].title)
      this.getTrendsRanking()
    },
    // 获取底图采集
    async getStudentBaseMapCount(params) {
      const res = await getAction('/statisticV2/getStudentBaseMapCount', params)
      if (res.success) {
        this.baseMapInfo = res.result
      }
    },
    // 获取抓拍覆盖数据
    async getDeviceCollectedData(params) {
      const res = await getAction('/statisticV2/getDeviceCollectedData', params)
      if (res.success) {
        this.collectedInfo = res.result
      }
    },
    // 重点学生概览
    async getKeyCareStudents() {
      const res = await getAction('/statisticV2/getKeyCareStudents')
      const { success, result } = res
      if (success) {
        const mainStuView = {
          ...result,
          chartData: result.chartData.filter((item) => item.type != 4),
          legendArr: result.chartData,
          path: '/CommonPage/MainCareStuOverview',
        }
        this.$set(this.mainCareStu.list, '0', mainStuView)
        const findItem = mainStuView.chartData.find((item) => item.type == 4)
        if (findItem) {
          this.$set(findItem, 'color', '#FA3A25')
        }
      }
    },
    // 获取重点学生关爱情况、心理健康工作统计概况数据
    getRectorWorkbench() {
      getAction('/home/rectorWorkbench').then((res) => {
        if (res.success) {
          const { ygaStudentCnt, dgaStudentCnt, zgaCnt, planCnt, fdCnt, jxgtCnt, bzrgtCnt } =
            res.result
          const chartData1 = [
            { value: ygaStudentCnt, name: '已关爱学生数' },
            { value: dgaStudentCnt, name: '待关爱学生数' },
          ]
          const legendArr1 = [
            { value: zgaCnt, name: '累计关爱次数', isNotHasDetail: true },
            { value: ygaStudentCnt, name: '已关爱学生数' },
            { value: dgaStudentCnt, name: '待关爱学生数' },
          ]
          const total1 = chartData1.reduce((acc, cur, index) => acc + cur.value, 0)
          const textData = [
            {
              value: planCnt,
              name: '心理测评次数',
              path: '/CommonPage/MyWordPlan',
              query: { radioKey: 2 },
            },
            { value: fdCnt, name: '心理辅导次数', path: '/CommonPage/PsyCounselNum' },
            { value: jxgtCnt, name: '家访次数' },
            { value: bzrgtCnt, name: '班主任沟通次数' },
          ]

          this.$set(this.mainCareStu.list[1], 'chartData', chartData1)
          this.$set(this.mainCareStu.list[1], 'legendArr', legendArr1)
          this.$set(this.mainCareStu.list[1], 'pieText', [total1, '总人数'])
          this.$set(this.mentalHealthObj.list[1], 'chartData', textData)
        }
      })
    },
    // 提醒学生概况
    async getReminderData() {
      const res = await getAction('/statisticV2/getReminderData', {
        beginDate: this.remindStuDateRange?.[0],
        endDate: this.remindStuDateRange?.[1],
      })
      const { success, result } = res
      if (success) {
        const { doneNum, pendingNum, totalNum, processRate } = result
        this.teacherHandInfo = {
          ...result,
          untreatedRate: processRate == 0 ? 0 : Number((100 - processRate).toFixed(2)),
        }
        const chartData = [
          { value: doneNum, name: '已处理提醒人次' },
          { value: pendingNum, name: '未处理提醒人次' },
        ]
        const pieText = [totalNum, '总提醒人次']
        this.$set(this.remindStu.list[0], 'chartData', chartData)
        this.$set(this.remindStu.list[0], 'pieText', pieText)
        this.$set(this.remindStu.list[0], 'rate', processRate)
      }
    },
    // 心理辅导
    async getStudentCounselingData() {
      const res = await getAction('/AppTwo/getStudentCounselingData', {
        beginDate: this.mentalDateRange?.[0],
        endDate: this.mentalDateRange?.[1],
      })
      const pcRes = await getAction('/statisticV2/getPcAllTutoringCount', {
        beginDate: this.mentalDateRange?.[0],
        endDate: this.mentalDateRange?.[1],
        role: this.identityId,
      })
      const totalcounsel = pcRes.result?.total
      const totalWithFeedbackCount = pcRes.result?.totalWithFeedbackCount
      const { success, result } = res

      if (success) {
        const {
          unconfirmedCount,
          unTutoredCount,
          tutoredCount,
          teacherBookingTotal,
          parentBookingTotal,
          totalAppointNum,
          mentalBookingRate,
        } = result
        const chartData = [
          { value: unconfirmedCount, name: '预约未确认' },
          { value: unTutoredCount, name: '未辅导' },
          { value: tutoredCount, name: '已辅导' },
        ]
        const legendArr = [
          { value: totalcounsel, name: '辅导记录', path: '/CommonPage/CommonReminder' , type: 2 ,query: { commonType: 'counseling' }, loading: false },
          { value: teacherBookingTotal, name: '班主任预约', path: '/CommonPage/PsyCounselAppointment' , type: 1, loading: false },
          { value: parentBookingTotal, name: '家长预约', path: '/CommonPage/PsyCounselAppointment' , type: 2, loading: false },
          { value: totalWithFeedbackCount, name: '危机上报', path: '/CommonPage/CommonReminder' , type: 4 ,query: { commonType: 'crisis' }, loading: false },
        ]
        this.$set(this.mentalHealthObj.list[0], 'chartData', chartData)
        this.$set(this.mentalHealthObj.list[0], 'pieText', [totalAppointNum, '总辅导次数'])
        this.$set(this.mentalHealthObj.list[0], 'legendArr', legendArr)
        this.$set(this.mentalHealthObj.list[0], 'rate', mentalBookingRate)
      }
    },
    // 年级、班级情绪趋势排名
    getTrendsRanking() {
      getAction(this.emotionalTrend.url, {
        beginDate: this.queryParam.beginDate,
        endDate: this.queryParam.endDate,
      }).then((res) => {
        if (res.success) {
          const schoolData = res.result.map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
            }
          })
          this.$set(this.emotionalTrend, 'tableData', schoolData)
        }
      })
    },
    getSearchKeyword() {
      getAction('/statistic/getKeyword', this.queryParam).then((res) => {
        if (res.success) {
          this.searchContextList = res.result
          this.keyword = res.result
        }
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeType = 'range'
      this.rangeDate = dates
      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
      this.moodField = ['愉悦指数', '关爱名单愉悦指数']
      this.searchItem = []
    },
    handleSearch: simpleDebounce(function (value) {
      this.queryParam.con = value || ''
      if (!this.searchContextList.length) {
        this.getSearchKeyword()
      } else {
        this.keyword = value
          ? this.searchContextList.filter((item) => item.name.includes(value))
          : this.searchContextList
      }
    }, 300),
    handleSelect(value, item) {
      console.log('添加对比：', item)
      this.$set(this.queryParam, 'crux', item.name)
      this.$set(this.queryParam, 'id', value)
      if (value) {
        if (!this.searchItem.includes(this.queryParam.crux)) {
          this.searchItem.push(this.queryParam.crux)
          this.searchItemColor.push(randomColor())
        }
        this.context2 = ''
        this.addCompareData({ dataType: item.dataType, tenantId: item.tenantId })
      }
      this.contrastInputStatus = false
      this.keyword = this.searchContextList
      this.$refs.moodChangeDescRef.addItem(item)
    },
    deleteBtn(item) {
      console.log('删除对比项：', item)
      console.log('this.schoolMood--', this.schoolMood)
      const lineData = deleteLineCompare(this.schoolMood, item)
      const idx_s = this.searchItem.indexOf(item)
      this.searchItem.splice(idx_s, 1)
      this.searchItemColor.splice(idx_s, 1)
      const idx = this.moodField.indexOf(item)
      if (idx == -1) return
      this.moodField.splice(idx, 1)
      this.schoolMood = lineData
      this.$refs.moodChangeDescRef.deleteItem(item)
    },
    addContrast() {
      this.contrastInputStatus = true
    },
    addContrastCell(record) {
      console.log('添加对比', record)
      this.$set(this.queryParam, 'id', record.class_id || record.grade_id)
      this.$set(this.queryParam, 'crux', record.name)
      if (!this.searchItem.includes(this.queryParam.crux)) {
        this.searchItem.push(this.queryParam.crux)
        this.searchItemColor.push(randomColor())
      }
      this.addCompareData({
        tenantId: record.tenantId,
      })
      const recordId = (record.class_id || record.grade_id).split('-')[0]
      const type = (record.class_id || record.grade_id).split('-')[1]
      this.$refs.moodChangeDescRef.addItem({
        ...record,
        id: recordId,
        type,
      })
    },
    // 添加事件
    addEventClick() {
      this.$refs.addEventModal.show(this.schoolMood, this.moodField)
    },
    // 刷新标注
    refreshMarked(record) {
      const porintIndex = this.schoolMood.findIndex(
        (item) => item[record.filed + 'id'] == record.id && item.type == record.type
      )
      if (porintIndex != -1) {
        const incident = record.filed + 'incident'
        this.$set(this.schoolMood[porintIndex], incident, record['incident'])
        this.schoolMood = [...this.schoolMood]
        // console.log('刷新标注的索引：', porintIndex);
        // console.log('刷新标注后的数据：', this.schoolMood);
      }
    },
    // 教师列表分页变化
    handleTableChange(page, _, sorter) {
      // this.pagination = page
      // this.getTeacherSituation(sorter)
    },
    // 教师访问量趋势
    async getTeacherVisitTrend(params) {
      const res = await getAction('/statistic/teacherVisit', params)
      if (res.success) {
        this.$set(this.teacherVisitChart, 'dataSource', res.result.resultList)
      }
    },
    // 学生活跃度对比
    getStudentActivityTrend(params) {
      //学生活跃情况
      getAction('/statistic/studentActivityTrend', params)
        .then((res) => {
          this.$refs.studentActivityRef.showLoading()
          if (res.success) {
            this.studentActivity = res.result?.map?.((item) => ({
              type: item.type,
              学生活跃度: item.activity,
            }))
          }
        })
        .finally(() => {
          this.$refs.studentActivityRef.hideLoading()
        })
    },
    // 获取家长关注度对比
    getParentVisitTrend(params) {
      getAction('/statistic/parentVisitTrend', params)
        .then((res) => {
          this.$refs.parentVisitRef.showLoading()
          if (res.success) {
            this.parentVisit = res.result?.map?.((item) => ({
              type: item.type,
              家长活跃度: item.visit,
            }))
          }
        })
        .finally(() => {
          this.$refs.parentVisitRef.hideLoading()
        })
    },
    // 教师使用情况一键提醒
    async teacherUseOneRemind() {
      this.remindLoading = true
      const res = await getAction('/statistic/teacherSituation', {
        beginDate: this.teaVisitDateRange[0],
        endDate: this.teaVisitDateRange[1],
        type: 1,
      })
      this.remindLoading = false
      const { success, result } = res
      if (success) {
        this.$message.success(result || '一键提醒成功')
      } else {
        this.$message.error(result || '一键提醒失败')
      }
    },
    // 教师使用情况列表
    getTeacherSituation(params) {
      this.teaLoading = true
      getAction('/statistic/teacherSituation', params)
        .then((res) => {
          if (res.success) {
            const classData = res.result.map((item, index) => {
              return {
                ...item,
                index: index + 1,
              }
            })
            this.$set(this.teacherUseList, 'tableData', classData)
          }
        })
        .finally(() => {
          this.teaLoading = false
        })
    },
    teacherRemindList(record) {
      const id = record.teacherId
      const customText =
        record.teacherName +
        '老师您好，您收到一条来自后台' +
        '的提醒消息，本周您还有' +
        record.unDealWarnCnt +
        '条提醒未处理，请及时跟进处理。'

      const requestData = {
        teacherId: id,
        text: customText,
      }
      //催办班主任提醒处理
      getAction('/aigoes/schoolClass/earlyWarning', requestData).then((res) => {
        console.log(res)
        if (res.success) {
          // this.$message.success('催办成功！');
          this.$notification['success']({
            message: '通知',
            description: '已提醒班主任！',
          })
        }
      })
    },
    goNotCollectDetail() {
      this.$router.push({
        path: '/CommonPage/NotCollectedBasemap',
        query: {
          dateRange: this.equipmentDateRange,
        },
      })
    },
    // 查看教师关怀
    viewTeacherCare(data) {
      data.name = data.teacherName
      data.id = data.teacherId
      this.$refs.teacherCareModal.show(data)
    },
    equipmentQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.equipmentTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: formatYearMonthDate(this.equipmentDateRange[0]),
        endDate: formatYearMonthDate(this.equipmentDateRange[1]),
      }
      this.equipmentDateRange = [dateRangeObj.beginDate, dateRangeObj.endDate]
      this.getStudentBaseMapCount(dateRangeObj)
      this.getDeviceCollectedData(dateRangeObj)
    },
    vitalityQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.activityTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: formatYearMonthDate(this.vitalityDateRange[0]),
        endDate: formatYearMonthDate(this.vitalityDateRange[1]),
      }
      this.getStudentActivityTrend(dateRangeObj)
      this.getParentVisitTrend(dateRangeObj)
    },
    async remindStuQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.remindStuTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: this.remindStuDateRange?.[0] && formatYearMonthDate(this.remindStuDateRange[0]),
        endDate: this.remindStuDateRange?.[1] && formatYearMonthDate(this.remindStuDateRange[1]),
      }
      // 格式化数组日期格式
      this.remindStuDateRange = [dateRangeObj?.beginDate, dateRangeObj?.endDate]
      await this.getReminderData()
      // dom生成之后再调用
      if (this.$refs.classTeaHandSituatRef) {
        await this.$refs.classTeaHandSituatRef.getReminderDataList(dateRangeObj)
      }
    },
    async mentalQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.mentalTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: this.mentalDateRange?.[0] && formatYearMonthDate(this.mentalDateRange[0]),
        endDate: this.mentalDateRange?.[1] && formatYearMonthDate(this.mentalDateRange[1]),
      }
      // 格式化数组日期格式
      this.mentalDateRange = [dateRangeObj?.beginDate, dateRangeObj?.endDate]
      this.$set(this.mentalHealthObj.list[0], 'query', dateRangeObj)
      await this.getStudentCounselingData()
    },
    teaVisitQuery(isQuery) {
      // isQuery为是否点击查询，为true时，清空时间标签选择
      if (isQuery) {
        this.teaVisitTagIndex = -1
      }
      const dateRangeObj = {
        beginDate: formatYearMonthDate(this.teaVisitDateRange[0]),
        endDate: formatYearMonthDate(this.teaVisitDateRange[1]),
      }
      // 格式化数组日期格式
      this.teaVisitDateRange = [dateRangeObj.beginDate, dateRangeObj.endDate]
      this.getTeacherVisitTrend(dateRangeObj)
      this.getTeacherSituation(dateRangeObj)
    },
    viewTeaUsageModal() {
      this.$refs.teacherUsageModalRef.showModal({
        beginDate: this.teaVisitDateRange[0],
        endDate: this.teaVisitDateRange[1],
      })
    },
    // 查询当前租户是否开通C端
    async checkCOpenStatus() {
      const res = await getAction('/statisticV2/c-open/status')
      const { success, result } = res
      if (success) {
        this.isShowActivity = result
      }
    },
    targetFn() {
      return document.querySelector('.outer-layer-roll')
    },
  },
}
</script>
<style scoped lang="less">
.child-full-width {
  margin-left: -10px; /* 负边距抵消父元素的左内边距 */
  margin-right: -10px; /* 负边距抵消父元素的右内边距 */
  width: calc(100% + 20px); /* 补偿负边距 */
  border-radius: 20px 20px 0 0;
  padding: 0 10px;
}
.overview-bgColor {
  background: linear-gradient(#cfdfff 0%, #f8f8f8 100%);
  /deep/ .ant-select {
    width: 100% !important;
  }
}
.teacher-manage-bgColor {
  background: linear-gradient(#ffcca8 0%, #f0f2f5 75%);
}
.psy-teacher-manage-bgColor {
  background: linear-gradient(#fdcec8 0%, #f0f2f5 75%);
}
.tag-col {
  animation: tagAppear 0.3s linear;
}

.select-box {
  position: relative;
  animation: tagAppear 0.3s linear;
}

@keyframes tagAppear {
  from {
    transform: translate(20px, -20px) scale(0.4);
    opacity: 0;
  }
  to {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
}

.tag-item {
  width: 100% !important;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding-left: 5px;
  /* 不换行 */

  .tag-name {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.delete-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -6px;
}

.select-del-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -1px;
  right: 3px;
}

.line-title {
  font-size: 17px;
  font-weight: 600;
  color: #262626;
  font-family: 'Arial', sans-serif;
}

.virtual-list {
  /* y轴滚动 */
  overflow-y: auto;
  /* 隐藏x轴滚动条 */
  overflow-x: hidden;

  .list-item {
    display: flex;
    align-items: center;
    padding-left: 10px;
    min-height: 40px;
    font-size: 14px;
    cursor: pointer;
  }

  .list-item:hover {
    background-color: #e6f7ff;
  }
}

.left-card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  // margin: 10px;
  ::v-deep {
    .ant-card-body {
      padding-bottom: 16px;
    }
  }
}

.right-card-box {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  /deep/ .ant-pagination {
    margin-bottom: 0 !important;
  }
  ::v-deep {
    .ant-card-body {
      padding-bottom: 16px;
    }
  }
  /deep/ .ant-table-hide-scrollbar {
    width: 100.8% !important;
  }
  /deep/ .ant-table-thead {
    background: #fafafa !important;
  }

  /deep/ .ant-table-header {
    background: #fafafa !important;
  }
}

.emotional-trend-card {
  padding: 0 10px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  ::v-deep {
    .ant-tabs-bar {
      margin-bottom: 10px !important;
    }
  }
  ::v-deep {
    .ant-card-body {
      padding: 0 16px;
    }
  }
  /deep/ .ant-table-hide-scrollbar {
    width: 101.6% !important;
  }
}

.title-right-extra {
  width: 100%;
  margin-bottom: 10px;
  font-size: 16px;
  color: #333333;
  font-weight: bold;

  .tea-text {
    margin-left: 15px;
    font-size: 15px;
    font-weight: 500;
    color: #404040;

    .tea-text-num {
      font-size: 16px;
      color: #3ba1f5;
    }
  }
}

.equipment-list {
  gap: 20px;
  .equipment-item {
    box-sizing: border-box;
    flex: 1;
    height: 164px;
    padding: 25px 20px;
    background-color: #fff;
    border-radius: 12px;
    .font-text {
      margin-top: 10px;
      font-size: 28px;
      font-weight: 600;
    }
    .icon-area {
      margin-top: -10px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
  }
  .num {
    font-size: 18px;
    color: #ff0000;
    font-weight: 500;
  }
  .equipment-other-item {
    box-sizing: border-box;
    flex: 3.5;
    height: 164px;
    background-color: #fff;
    border-radius: 11px;
    padding: 12px 20px;
  }
}

.tag-list {
  .list-tag-item {
    width: 54px;
    height: 24px;
    margin: 6px;
    line-height: 24px;
    text-align: center;
    background: #eff4fc;
    border-radius: 4px;
    color: #404040;
    font-size: 12px;
    cursor: pointer;
  }
  .active-tag {
    background: #009dff;
    color: #fff;
  }
}

.row-box {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 20px 10px;
  margin-bottom: 10px;
  border-radius: 8px;
}
.pie-item {
  width: 50%;
  padding: 10px 12px;
  &:nth-child(odd) {
    padding-left: 0;
  }
  &:nth-child(even) {
    padding-right: 0;
  }
}

.row-box-card {
  box-sizing: border-box;
  gap: 20px;
  padding: 20px;
  border-radius: 8px;
  background-color: #fff;
  .pie-item-card {
    box-sizing: border-box;
    flex: 1;
    height: 420px;
    padding: 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    .title-num {
      font-size: 20px;
      color: #2993e4;
    }
    .sub-text {
      color: #e16156;
      font-weight: bold;
    }
    .title-block {
      display: inline-block;
      width: 4px;
      height: 14px;
      margin-right: 4px;
      background: #1790f7;
      border-radius: 2px;
    }
  }
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

/deep/ .ant-back-top {
  right: 50px !important;
  z-index: 99;
}
</style>
